import * as moment from 'moment';
import { Directive, HostListener, Optional } from '@angular/core';
import { KEY_CODE } from '@app/shared/key-code.const';
import { NgControl } from '@angular/forms';
import { hasValue } from '@app/shared/comparison-helpers.service';

const directiveSelector = 'datePickerEvtHandler';

const rightArrowEvent = new KeyboardEvent('keydown', {
  keyCode: 39,
  key: 'ArrowRight'
} as KeyboardEventInit);

const leftArrowEvent = new KeyboardEvent('keydown', {
  keyCode: 37,
  key: 'ArrowLeft'
} as KeyboardEventInit);

const generalDateFieldKeys = [
  'Backspace', // BACKSPACE
  'Tab', // TAB
  'Enter', // ENTER
  'Escape', // ESCAPE
  'Delete', // DELETE
  '/' // FORWARD SLASH
];

@Directive({
  selector: `[${directiveSelector}]`
})
export class DatepickerHelperDirective {
  constructor(@Optional() private baseControl: NgControl) {}

  @HostListener('opened')
  pickerOpened(): void {
    const calendarContent = document.getElementsByClassName('mat-calendar-content')[0];
    if (hasValue(calendarContent)) {
      calendarContent.addEventListener('keypress', (keypress: KeyboardEvent) => {
        const calendarBody = document.getElementsByClassName('mat-calendar-body')[0];
        if (hasValue(calendarBody)) {
          if (keypress.code === 'NumpadAdd') {
            calendarBody.dispatchEvent(rightArrowEvent);
          } else if (keypress.code === 'NumpadSubtract') {
            calendarBody.dispatchEvent(leftArrowEvent);
          }
        }
      });
    }
  }

  @HostListener('keydown', ['$event', '$event.target.value'])
  inputKeyPressed(event: KeyboardEvent, value: any): void {
    if (
      generalDateFieldKeys.indexOf(event.key) !== -1 ||
      // Allow: Ctrl keys
      ((event.ctrlKey || event.metaKey) &&
        (event.key === KEY_CODE.A ||
          event.key === KEY_CODE.C ||
          event.key === KEY_CODE.V ||
          event.key === KEY_CODE.X ||
          event.key === KEY_CODE.Z)) ||
      event.key === KEY_CODE.RIGHT_ARROW ||
      event.key === KEY_CODE.LEFT_ARROW ||
      event.key === KEY_CODE.HOME ||
      event.key === KEY_CODE.END
    ) {
      return;
    }

    const isPlusMinusKey = event.code === 'NumpadAdd' || event.code === 'NumpadSubtract';

    if (!isPlusMinusKey && !parseInt(event.key, 10) && parseInt(event.key, 10) !== 0) {
      event.preventDefault();
      return;
    }

    if (hasValue(this.baseControl)) {
      if ((!hasValue(value) || value === '') && isPlusMinusKey) {
        event.preventDefault();
        this.baseControl.control.setValue(moment());
        return;
      }

      const valueAsMoment = moment(value, 'L');
      if (event.code === 'NumpadAdd') {
        event.preventDefault();
        this.baseControl.control.setValue(valueAsMoment.add(1, 'day'));
      } else if (event.code === 'NumpadSubtract') {
        event.preventDefault();
        this.baseControl.control.setValue(valueAsMoment.subtract(1, 'day'));
      }
    }
  }
}
